import React, { useEffect, useState } from "react";
import Button from "../components/Button";
import ContentBox from "../components/contents/ContentBox";
import PageWrapper from "../components/PageWrapper";
import OrderDetailsProduct from "../components/products/OrderDetailsProduct";
import { BaseURL, getData, putData2 } from "../FatchApi/FatchApi";
import { useParams } from "react-router-dom";
import Toastify from "../components/Toast/Toastify";
import { toast } from "react-toastify";

const OrderDetailsPage = () => {
  const { orderId } = useParams();

  const [orderStatus, setOrderStatus] = useState("");
  const [orderStatusValue, setOrderStatusValue] = useState([]);
  const [singleOrder, setSingleOrder] = useState("");
  const [shipToken, setShipToken] = useState("");
  const [shiprocketDetails, setShiprocketDetails] = useState(null);
  const [loadingShiprocket, setLoadingShiprocket] = useState(false);
  const [formData, setFormData] = useState({
    length: "",
    width: "",
    height: "",
    weight: "",
  });

  const GenerateTokenShiprocket = async () => {
    try {
      const response = await fetch(`${BaseURL}/api/shiprocket`, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ body: " " }),
      });
      const data = await response.json();
      if (data.token) {
        localStorage.setItem("shipToken", data.token);
        setShipToken(data.token);
        return data.token;
      } else {
        console.error("No token in Shiprocket login response:", data);
        return null;
      }
    } catch (error) {
      console.error("Failed to generate Shiprocket token:", error);
      toast.error("Failed to generate Shiprocket token", {
        position: toast.POSITION.TOP_RIGHT,
      });
      return null;
    }
  };

  const getOrderStatusValue = async () => {
    const res = await getData("api/orders/get-order-status");
    setOrderStatusValue(res);
  };

  const fetchShiprocketDetails = async (shipOrderId) => {
    if (!shipOrderId || shipOrderId === "Waiting for order accept") return;
    setLoadingShiprocket(true);
    try {
      const res = await getData(`api/shiprocket/details/${shipOrderId}`);
      if (res?.success) {
        setShiprocketDetails(res);
      } else {
        console.error("Failed to load Shiprocket details:", res);
      }
    } catch (error) {
      console.error("Error fetching Shiprocket details:", error);
    } finally {
      setLoadingShiprocket(false);
    }
  };

  const getSingleOrder = async () => {
    const res = await getData(`api/orders/get-single-order/${orderId}`);

    if (res.status === "success") {
      const order = res?.Orders ? res?.Orders[0] : "";
      setSingleOrder(order);
      if (order?.shipOrderId && order.shipOrderId !== "Waiting for order accept") {
        fetchShiprocketDetails(order.shipOrderId);
      }
    }
  };

  useEffect(() => {
    const init = async () => {
      await getSingleOrder();
      await getOrderStatusValue();
    };
    init();
  }, []);

  const address = singleOrder?.deliveryAddress?.address;
  const handleChange = (event) => {
    setOrderStatus(event.target.value);
  };

  const updateStatus = async () => {
    const body = {
      orderstatus: orderStatus,
    };
    const data = JSON.stringify(body);
    const ContentType = "application/json";
    const res = await putData2(`api/orders/update-order-status/${orderId}`, {
      data,
      ContentType,
    });
    if (res?.success) {
      toast.success("Order status updated successfully", {
        position: toast.POSITION.TOP_RIGHT,
      });
      getSingleOrder();
      getOrderStatusValue();
    } else {
      toast.error("Order status not updated");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Update the weight and height of package for shiprocket
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    //order sending on shiprocket

    if (singleOrder?.shipmentId == "Waiting for order accept") {
      if (
        formData.height !== "" &&
        formData.length !== "" &&
        formData.weight !== "" &&
        formData.width !== ""
      ) {
        // The backend logs in to Shiprocket itself
        const data = await fetch(`${BaseURL}/api/shiprocket/create`, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ orderId, formData }),
        });

        const res = await data.json();

        //Saving  shiprocket shipment Id and ship orderid in user order data base
        if (res?.success == true) {
          const data = JSON.stringify({
            shipmentId: res.data.shipment_id,
            shipOrderId: res.data.order_id,
          });

          const ContentType = "application/json";
          const orderres = await putData2(
            `api/orders/update-order/${orderId}`,
            { data, ContentType }
          );

          if (orderres.success) {
            setFormData({ length: "", width: "", height: "", weight: "" });
            getSingleOrder();
            toast.success("Order and Shipment ID updated in user Database ", {
              position: toast.POSITION.TOP_LEFT,
            });
          } else {
            toast.error(
              "Order and Shipment ID  not updated in user Order Database",
              {
                position: toast.POSITION.TOP_LEFT,
              }
            );
          }
        } else {
          toast.error(res?.data, {
            position: toast.POSITION.TOP_LEFT,
          });
        }
      } else {
        toast.error("Please fill the details For Shiprocket", {
          position: toast.POSITION.TOP_LEFT,
        });
      }
    } else {
      toast.error("The order has already been sent to ShipRocket", {
        position: toast.POSITION.TOP_LEFT,
      });
    }
  };
  return (
    <PageWrapper>
      <ContentBox name={`Order Id: ${orderId}`}>
        <Toastify close={"2000"} />
        <div className="border-b border-b-glitch-box"></div>
        <div className="px-5 py-5">
          {/* Ordered products */}
          <OrderDetailsProduct
            items={singleOrder?.items}
            price={111}
            units={2}
            quantity={1}
            image=""
          />
          <div className="mt-4">
            <div className="flex items-center justify-between border-b border-b-glitch-box py-2 text-white">
              <span>Item Total</span>
              <span>₹{singleOrder?.orderSummary?.cartTotal}</span>
            </div>

            <div className="flex items-center justify-between border-b border-b-glitch-box py-2 text-white">
              <span>Discount on Purchase</span>
              <span>
                -₹
                {singleOrder?.orderSummary?.discountOnPurchase}
              </span>
            </div>
            <div className="flex items-center justify-between border-b border-b-glitch-box py-2 text-white">
              <span>Coupon</span>
              <span>
                {singleOrder?.orderSummary?.couponeCode
                  ? `${singleOrder.orderSummary.couponeCode} (-₹${singleOrder?.orderSummary?.couponeValue || 0})`
                  : "-"}
              </span>
            </div>
            <div className="flex items-center justify-between border-b border-b-glitch-box py-2 text-white">
              <span>Total after Discount</span>
              <span>₹{singleOrder?.orderSummary?.totalAfterDiscount}</span>
            </div>
            <div className="flex items-center justify-between border-b border-b-glitch-box py-2 text-white">
              <span>Delivery</span>

              <span>
                {singleOrder?.orderSummary?.deliveryCharges == "Free" ||
                Number(singleOrder?.deliveryCharges ?? singleOrder?.orderSummary?.deliveryCharges) === 0
                  ? "Free"
                  : "+₹" + (singleOrder?.deliveryCharges ?? singleOrder?.orderSummary?.deliveryCharges)}
              </span>
            </div>
            <div className="flex items-center justify-between border-b border-b-glitch-box py-2 text-white">
              <span>Grand Total (Inc.of Taxes and Delivery Charge)</span>
              <span className="text-green-300">
                ₹{singleOrder?.orderSummary?.totalAfterDiscountAndDeliverCharge}
              </span>
            </div>
          </div>

          <hr className="w-full border-b border-b-glitch-box my-5" />

          {/* Customer details */}
          <div className="mt-4">
            <div className="text-white flex items-center justify-between">
              <div className="font-medium">CUSTOMER DETAILS</div>
            </div>
            <div className="flex items-center justify-between border-b border-b-glitch-box py-2 text-white">
              <span>Name</span>
              <span>{address?.name}</span>
            </div>
            <div className="flex items-center justify-between border-b border-b-glitch-box py-2 text-white">
              <span>Mobile</span>
              <div>
                <span>{address?.mobile_Number} </span>
                <button className="material-icons-outlined text-lg px-1 bg-blue-500 text-white rounded">
                  phone
                </button>
              </div>
            </div>
            <div className="flex items-center justify-between border-b border-b-glitch-box py-2 text-base text-white">
              <span>Address</span>
              <span>
                {address?.locality},{address?.city},{address?.state}
              </span>
            </div>
            <div className="flex items-center justify-between border-b border-b-glitch-box py-2 text-base text-white">
              <span>Pin Code</span>
              <span>{address?.pincode}</span>
            </div>
            <div className="flex items-center justify-between border-b border-b-glitch-box py-2 text-base text-white">
              <span>City</span>
              <span>{address?.city}</span>
            </div>
            <div className="flex items-center justify-between border-b border-b-glitch-box py-2 text-base text-white">
              <span>Payment</span>
              <Button>
                <span className="text-yellow-400 px-1">
                  {" "}
                  {singleOrder?.isPaid ? "Paid" : "Cash on Delivery"}
                </span>
              </Button>
            </div>
            <div className="flex items-center justify-between border-b border-b-glitch-box py-2 text-base text-white">
              <span> Order Status</span>
              <Button>
                <span className="text-yellow-400 px-1">
                  {" "}
                  {singleOrder?.orderstatus}
                </span>
              </Button>
            </div>
            <div className="flex items-center justify-between border-b border-b-glitch-box py-2 text-base text-white">
              <span>Shiprocket OrderId</span>

              <span className="text-yellow-400 px-1">
                {" "}
                {singleOrder?.shipOrderId}
              </span>
            </div>
            <div className="flex items-center justify-between border-b border-b-glitch-box py-2 text-base text-white">
              <span>Shipment Id</span>

              <span className="text-yellow-400 px-1">
                {" "}
                {singleOrder?.shipmentId}
              </span>
            </div>
          </div>

          {/* Order actions */}
          <div class="flex mb-3">
            {/* <Button className="hover:bg-rose-500">
                <span className="material-icons text-lg mr-2 py-1">close</span>
                <span>Reject</span>
              </Button> */}
            <select
              id="countries"
              class="bg-gray-50 h-10 px-6  border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
              value={orderStatus}
              onChange={handleChange}
            >
              <option selected> Update Order Status </option>
              {orderStatusValue?.map((value) => {
                return (
                  <>
                    <option value={value}>{value}</option>
                  </>
                );
              })}
            </select>
            <div class="group relative mx-5">
              <button
                className="h-10 px-6  font-semibold rounded-xl bg-red hover:bg-indigo-500 text-white"
                onClick={updateStatus}
              >
                Update
              </button>
            </div>
            <div>
              <button
                disabled={singleOrder?.orderstatus !== "Shipped"}
                onClick={GenerateTokenShiprocket}
                className="h-10 px-6  font-semibold rounded-xl text-sm bg-red hover:bg-indigo-500 text-white"
              >
                Verify Shipro
              </button>
            </div>
            {singleOrder?.orderstatus === "Shipped" &&
              singleOrder?.shipOrderId &&
              singleOrder?.shipOrderId !== "Waiting for order accept" && (
                <div className="mx-5">
                  <a
                    href={`https://app.shiprocket.in/seller/orders/details/${singleOrder?.shipOrderId}`}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex items-center justify-center h-10 px-6 font-semibold rounded-xl text-sm bg-green-600 hover:bg-green-500 text-white transition-all"
                  >
                    <span className="material-icons text-base mr-2">
                      open_in_new
                    </span>
                    Check on Shiprocket
                  </a>
                </div>
              )}
          </div>
          {shipToken &&
          singleOrder?.orderstatus === "Shipped" &&
          singleOrder?.shipmentId === "Waiting for order accept" ? (
            <div>
              {" "}
              Please fill these details for Shiprocket
              <form
                encType="multipart/form-data"
                onSubmit={handleSubmit}
                className="grid grid-cols-2 gap-4 mx-auto"
              >
                <div className="mb-4">
                  <label htmlFor="length" className="block mb-1 font-medium">
                    Length in cm
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded"
                    id="length"
                    name="length"
                    value={formData.length}
                    onChange={(e) => handleInputChange(e)}
                    required
                    placeholder="Package Length in (0.0)"
                  />
                </div>

                <div className="mb-4">
                  <label htmlFor="breadth" className="block mb-1 font-medium">
                    Breadth in cm
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded"
                    id="breadth"
                    name="width"
                    value={formData.width}
                    onChange={(e) => handleInputChange(e)}
                    required
                    placeholder="Package Width (0.0)"
                  />
                </div>

                <div className="mb-4">
                  <label htmlFor="height" className="block mb-1 font-medium">
                    Height in cm
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded"
                    id="height"
                    name="height"
                    value={formData.height}
                    onChange={(e) => handleInputChange(e)}
                    required
                    placeholder="Package Height (0.0)"
                  />
                </div>

                <div className="mb-4">
                  <label htmlFor="weight" className="block mb-1 font-medium">
                    Weight in Kg
                  </label>
                  <input
                    type="text"
                    className="w-full px-3 py-2 border border-gray-300 rounded"
                    id="weight"
                    name="weight"
                    value={formData.weight}
                    onChange={(e) => handleInputChange(e)}
                    required
                    placeholder="Package Weight (0.0)"
                  />
                </div>
                <div className="text-center">
                  <button
                    className="px-4 py-2 text-white bg-blue-500 rounded hover:bg-blue-600"
                    type="submit"
                  >
                    Save Product
                  </button>
                </div>
              </form>{" "}
            </div>
          ) : (
            <div className="mt-6 text-white bg-slate-900/60 p-5 rounded-xl border border-gray-800">
              <h3 className="text-lg font-semibold text-indigo-400 mb-4 flex items-center">
                <span className="material-icons text-xl mr-2">local_shipping</span>
                Shiprocket Delivery Details
              </h3>

              {singleOrder?.shipOrderId === "Waiting for order accept" ? (
                <p className="text-gray-400 italic">Please Ship Order for Shiprocket (update status to Shipped first).</p>
              ) : (
                <div>
                  {loadingShiprocket ? (
                    <div className="flex items-center space-x-2 text-gray-400">
                      <span className="material-icons animate-spin mr-2">sync</span>
                      <span>Fetching live details from Shiprocket...</span>
                    </div>
                  ) : (
                    <div>
                      {/* Shiprocket details layout */}
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-5">
                        <div className="border-b border-gray-800 pb-2 md:border-none md:pb-0">
                          <span className="text-gray-400 text-xs block uppercase tracking-wider">Shiprocket Order ID</span>
                          <span className="text-sm font-semibold">{singleOrder?.shipOrderId}</span>
                        </div>
                        <div className="border-b border-gray-800 pb-2 md:border-none md:pb-0">
                          <span className="text-gray-400 text-xs block uppercase tracking-wider">Shipment ID</span>
                          <span className="text-sm font-semibold">{singleOrder?.shipmentId}</span>
                        </div>
                        <div className="border-b border-gray-800 pb-2 md:border-none md:pb-0">
                          <span className="text-gray-400 text-xs block uppercase tracking-wider">Courier Partner</span>
                          <span className="text-sm font-semibold text-yellow-400">
                            {shiprocketDetails?.order?.courier_name || "Assigning..."}
                          </span>
                        </div>
                        <div className="border-b border-gray-800 pb-2 md:border-none md:pb-0">
                          <span className="text-gray-400 text-xs block uppercase tracking-wider">AWB Code (Tracking Code)</span>
                          {shiprocketDetails?.order?.awb_code ? (
                            <div className="flex items-center space-x-2 mt-1">
                              <span className="text-sm font-mono text-green-400 font-bold">
                                {shiprocketDetails.order.awb_code}
                              </span>
                              <button
                                type="button"
                                className="text-xs bg-gray-800 hover:bg-gray-700 px-2 py-0.5 rounded text-gray-300 transition-colors"
                                onClick={() => {
                                  navigator.clipboard.writeText(shiprocketDetails.order.awb_code);
                                  toast.success("AWB copied to clipboard!", {
                                    position: toast.POSITION.TOP_RIGHT,
                                  });
                                }}
                              >
                                Copy
                              </button>
                            </div>
                          ) : (
                            <span className="text-sm text-gray-500 italic">Not generated yet</span>
                          )}
                        </div>
                        <div className="col-span-1 md:col-span-2">
                          <span className="text-gray-400 text-xs block uppercase tracking-wider">Shipment Status</span>
                          <span className="inline-block mt-1 bg-indigo-950 text-indigo-300 border border-indigo-800/50 text-xs px-3 py-1 rounded-full font-semibold">
                            {shiprocketDetails?.order?.status || "Processing"}
                          </span>
                        </div>
                      </div>

                      {/* Timeline/Activities section if available */}
                      {shiprocketDetails?.tracking?.tracking_data?.shipment_track_activities?.length > 0 && (
                        <div className="mt-5 border-t border-gray-800 pt-4">
                          <h4 className="text-sm font-semibold text-gray-300 mb-3 uppercase tracking-wider">Tracking Activities</h4>
                          <div className="relative border-l-2 border-indigo-900 pl-4 ml-2 space-y-4">
                            {shiprocketDetails.tracking.tracking_data.shipment_track_activities.map((act, idx) => (
                              <div key={idx} className="relative">
                                <div className="absolute -left-[21px] top-1.5 w-2 h-2 rounded-full bg-indigo-500 border border-slate-900"></div>
                                <div className="text-sm text-gray-200 font-medium">{act.activity}</div>
                                <div className="text-xs text-gray-400 flex items-center space-x-2 mt-0.5">
                                  <span>{act.location || "In Transit"}</span>
                                  <span>•</span>
                                  <span>{act.date}</span>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {/* Public Tracking Link Button */}
                      <div className="mt-6 flex flex-wrap gap-3">
                        <a
                          className="inline-flex items-center justify-center h-10 px-6 font-semibold rounded-xl bg-indigo-600 hover:bg-indigo-500 text-white text-sm transition-all"
                          href="https://www.shiprocket.in/shipment-tracking/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span className="material-icons text-base mr-2">travel_explore</span>
                          Track on Shiprocket Website
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </ContentBox>
    </PageWrapper>
  );
};

export default OrderDetailsPage;
